<template>
    <div v-show="visible"
         title=""
         style="width: 100%; height: 100%; background-color: rgba(7,7,7,.3); display: flex; align-items: center; justify-content: center; position: fixed; top: 0px; left: 0px;"
         class="popup-overlay"
         ref="popup-inner"
         v-bind:style="{'z-index': zIndex}"
    >
        <div
                style="background-color: white; box-shadow: 0 20px 25px -3px rgba(0, 0, 0, 0.1), 0 10px 14px -4px rgba(0, 0, 0, 0.05);"
                :style="containerStyle"
                :class="containerClass"
                class="popup-inner"
        >
            <slot></slot>
            <div style="width: 100%; display: flex; justify-content: center; padding-top: 1em; padding-bottom: 1em"
                 class="popup-inner-button-container"
                 v-if="showCloseButton">
                <button v-html="closeButtonLabel" :class="closeButtonClass"
                        v-on:click.self="closePopup"></button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            visible: {type: Boolean},
            containerStyle: {type: String, default: 'width: auto; min-width:65%; padding: 0px; max-height: 90%;'},
            containerClass: {type: String, default: ''},
            showCloseButton: {type: Boolean, default: false},
            closeButtonLabel: {type: String, default: ''},
            closeButtonClass: {type: String, default: 'btn btn-primary'},
        },
        data: function() {
            return {
                zIndex: 0,
            }
        },
        methods: {
            closePopup: function() {
                this.$refs['popup-inner'].classList.remove('popup-inner-active');
                this.$emit('close')
            },
            maxParentZIndex: function() {
                if (!this.$refs['popup-inner']) {
                    return 0;
                }
                let result = 0;
                let maxZ = 0;
                let node = this.$refs['popup-inner'].parentNode;
                while ((node) && (node.nodeName != 'HTML')) {
                    maxZ = window.getComputedStyle(node).zIndex;
                    if ((maxZ != 'auto') && (parseInt(maxZ) > result)) {
                        result = maxZ;
                    }
                    node = node.parentNode;
                }

                return result;
            }
        },
        watch: {
            visible: function(value) {
                if (value) {
                    this.zIndex = parseInt(this.maxParentZIndex()) + 10;
                    window.setTimeout(() => {
                        this.$refs['popup-inner'].classList.add('popup-inner-active');
                    }, 100);
                } else {
                    this.zIndex = 0;
                    window.setTimeout(() => {
                        this.$refs['popup-inner'].classList.remove('popup-inner-active');
                    }, 100);
                }
            }
        },
        computed: {
        }
    }
</script>
<style>
    .popup-overlay {
        opacity: 0;
        transition: opacity 300ms ease-in-out;
    }
    .popup-inner-active {
        opacity: 1;
    }
</style>
